import React, { useEffect, type ReactNode, type ReactElement } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

import { getAccountsModulesSaga } from "../../actions/accountModules";
import { userService } from "../../services/user";
import { getHashValue } from "../../services/jusCan";

type Props = {
  children: ReactNode,
};

function AppStoreWrapper({ children }: Props): ReactElement {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isHaveAccess = userService.can([{ path: "/api/v1/jus/accounts", method: "GET" }]);
  const hashValue = getHashValue();

  useEffect(() => {
    if (hashValue) {
      dispatch(getAccountsModulesSaga(["linking", "document", "resource"]));
    }
  }, [dispatch, hashValue]);

  useEffect(() => {
    if (!isHaveAccess) {
      navigate("/accessDenied");
    }
  }, [isHaveAccess, navigate]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}

export default AppStoreWrapper;
